import { ArrowLeft, Plus } from "lucide-react";

import { Button, PermissionGuard } from "@/components";
import { useI18n } from "@/context/i18n";

import { TableInsuranceCompanies } from "./components";
import { useInsuranceCompanies } from "./insurance-companies.hooks";
import { getInsuranceCompanyTypeLabel } from "./insurance-companies.type";
import { InsuranceCompaniesForm } from "./insurance-companies-form";

export const InsuranceCompaniesPage: React.FC = () => {
  const { t } = useI18n();

  const {
    openInsuranceCompaniesForm,
    closeInsuranceCompaniesForm,
    isInsuranceCompaniesFormOpen,
    insuranceCompaniesForm,
    insuranceCompanies,
    handleInsuranceCompanyFormSubmit,
    deleteInsuranceCompany,
    editInsuranceCompany,
    editingId,
    insuranceCompanyById,
  } = useInsuranceCompanies();

  return (
    <div className="flex flex-col w-full h-full space-y-6 p-4">
      <div className="flex flex-row items-start justify-between">
        <div className="flex flex-col w-full px-2">
          <div className="flex items-center gap-3 mb-3">
            {isInsuranceCompaniesFormOpen && (
              <Button
                type="button"
                variant="ghost"
                onClick={closeInsuranceCompaniesForm}
                size="sm"
                className="p-3 hover:bg-muted/50 transition-colors"
              >
                <ArrowLeft className="h-5 w-5" />
              </Button>
            )}
            <h1 className="text-3xl font-bold tracking-tight text-foreground">
              {t("insuranceCompanies.title")}
            </h1>
          </div>
          
          {isInsuranceCompaniesFormOpen && editingId && insuranceCompanyById ? (
            <div className="space-y-1">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-muted-foreground">
                  Editando a{" "}
                  {getInsuranceCompanyTypeLabel(
                    insuranceCompanyById.type,
                    t
                  ).toLowerCase()}
                  :
                </span>
                <span className="text-sm font-semibold text-primary">
                  {insuranceCompanyById.name}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-muted-foreground">
                  CNPJ:
                </span>
                <span className="text-sm font-semibold text-foreground">
                  {insuranceCompanyById.cnpj}
                </span>
              </div>
            </div>
          ) : (
            <p className="text-sm text-muted-foreground leading-relaxed">
              {t("insuranceCompanies.description")}
            </p>
          )}
        </div>
        
        {!isInsuranceCompaniesFormOpen && (
          <div className="flex justify-end">
            <PermissionGuard permission="insurance:create">
              <Button 
                onClick={openInsuranceCompaniesForm}
                className="shadow-sm hover:shadow-md transition-shadow"
              >
                <Plus className="mr-2 h-4 w-4" />
                {t("generic.new")}
              </Button>
            </PermissionGuard>
          </div>
        )}
      </div>

      <InsuranceCompaniesForm
        open={isInsuranceCompaniesFormOpen}
        onOpenChange={closeInsuranceCompaniesForm}
        form={insuranceCompaniesForm}
        onSubmit={handleInsuranceCompanyFormSubmit}
      />
      {/* back button moved to header; no duplicate below */}
      {!isInsuranceCompaniesFormOpen && (
        <TableInsuranceCompanies
          insuranceCompanies={insuranceCompanies}
          deleteInsuranceCompany={deleteInsuranceCompany}
          editInsuranceCompany={editInsuranceCompany}
        />
      )}
    </div>
  );
};
